import { clearAuthSession, getAccessToken } from "./auth";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || "http://localhost:8080";

function buildUrl(path) {
  if (!path.startsWith("/")) {
    return `${API_BASE_URL}/${path}`;
  }
  return `${API_BASE_URL}${path}`;
}

export async function apiRequest(path, options = {}) {
  const { method = "GET", body, headers = {}, auth = false } = options;
  const requestHeaders = { ...headers };

  if (!(body instanceof FormData) && !requestHeaders["Content-Type"]) {
    requestHeaders["Content-Type"] = "application/json";
  }

  if (auth) {
    const token = getAccessToken();
    if (!token) {
      const authError = new Error("Authentication required");
      authError.status = 401;
      throw authError;
    }
    requestHeaders.Authorization = `Bearer ${token}`;
  }

  const response = await fetch(buildUrl(path), {
    method,
    headers: requestHeaders,
    body: body instanceof FormData ? body : body ? JSON.stringify(body) : undefined,
  });

  let data = null;
  try {
    data = await response.json();
  } catch {
    data = null;
  }

  if (!response.ok) {
    const message = data?.message || "Request failed";
    const error = new Error(message);
    error.status = response.status;
    error.data = data;

    if (response.status === 401 || response.status === 403) {
      clearAuthSession();
    }

    throw error;
  }

  return data;
}
